/* DeleteAction.js */

"use strict";

class DeleteAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        activeView,
        userSession,
        NetworkDiscoveryPlan
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;

        this.doTheThang = this.doTheThang.bind(this);

        this._selectedPlan = this._gameEditor._networkDiscoveryPlanEntity;

        this.run = this.run.bind(this);
    }

    run() {
        let confirmDetails = {
                text: "Confirm",
                type: "destructive",
            },
            rejectDetails = {
                text: "Cancel",
                type: "text",
            };
        const message = "Are you sure you want to permanently delete the selected plan?\n";

        return this._gameEditor
            .runQuickConfirmationActionWorkflow(
                {
                    message: message,
                    title: "Delete",
                    confirmDetails,
                    rejectDetails,
                },
                this.doTheThang
            )
            .then(() => {
                this._gameEditor.currentEntityRemoved = true;
            })
            .catch(() => {
                this._gameEditor.currentEntityRemoved = false;
            });
    }

    doTheThang() {
        let workTarget = {
            method: "multi",
            ids: [this._selectedPlan.getId()],
        };

        const showProgFunc = () => {};
        return this._NetworkDiscoveryPlan
            .runDeleteNetworkDiscoveryPlansWork(
                this._activeOrgId,
                workTarget,
                {launchAndForget: false},
                showProgFunc
            )
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                this._gameEditor.currentEntityDeleteInProgress = false;
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete Discovery Plan",
    order: 7,
};
